import React, { useEffect } from "react";

import { Modal, Badge, Rate, Button } from "antd";

import { validarVisualizar } from "../../services/utils";

import TableHeader from "../Table/Header";
import TablePagination from "../Table/Pagination";

import favoritoSvg from "../../assets/icons/iconFavoritado.svg";
import pastaSvg from "../../assets/icons/pastaIcone.svg";
import infoArquivoSvg from "../../assets/icons/infoArquivo.svg";
import "./styles.scss";
import lang from "../../assets/idioma/idiomas";

const tabelaColunas = [
  <img src={favoritoSvg} />,
  lang.Nome,
  lang.Classificacao,
  lang.Autor,
  lang.Tamanho,
  lang.Tipo,
  lang.Data_de_inclusao,
];

const ModalListagemPastasArquivos = ({
  data,
  mudarPagina,
  pastasArquivosFilhos,
  closeModal,
  openModal,
}) => {
  const formatarData = (value) => {
    if (value) {
      const data = new Date(value);
      return data.toLocaleDateString("pt-BR", { timeZone: "UTC" });
    }
  };

  return (
    <>
      <div className="teste">
        <Modal
          onCancel={closeModal}
          visible={openModal}
          className="modal-upload"
          destroyOnClose={true}
          okButtonProps={{ disabled: true }}
          footer={[]}
        >
          <table className="table table-borderless col-lg-12">
            <TableHeader columns={tabelaColunas} />
            <tbody>
              {(!pastasArquivosFilhos?.lista ||
                pastasArquivosFilhos?.lista.length === 0) && (
                <tr>
                  <td colSpan="7"> Sem Registros </td>
                </tr>
              )}
              {pastasArquivosFilhos?.lista &&
                pastasArquivosFilhos?.lista?.map((item, index) => (
                  <tr key={index}>
                    <td>
                      {item.ehFavorito ? (
                        <img src={favoritoSvg} />
                      ) : (
                        <Badge status="default" />
                      )}
                    </td>
                    <td>
                      <span className="coluna-nome">
                        <img src={item.tipo == 0 ? pastaSvg : infoArquivoSvg} />
                        <span>{item.nome}</span>
                      </span>
                    </td>
                    <td>
                      {" "}
                      <Rate value={item.classificacao} />{" "}
                    </td>
                    <td> {item.autor} </td>
                    <td> {item.tamanho != 0 ? item.tamanho : " - "} </td>
                    <td> {item.tipo == 0 ? "Pasta" : item.extensao} </td>
                    <td> {formatarData(item.dataInclusao)} </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </Modal>
      </div>
    </>
  );
};

export default ModalListagemPastasArquivos;
